<template v-if="dbName" class="text-center">
    <!-- query source -->
    <div class="row" style="font-size:20px;">逆向查找来源:</div>
    <QuerySource :dbName="dbName" :colName="'elements'"></QuerySource>
    <QuerySource :dbName="dbName" :colName="'switches'"></QuerySource>
    <QuerySource :dbName="dbName" :colName="'variables'"></QuerySource>
    <QuerySource :dbName="dbName" :colName="'commonEvents'"></QuerySource>
    <QuerySource :dbName="dbName" :colName="'troops'"></QuerySource>
    <div class="row mt-4 mp-4"></div>
    <!-- <div class="row">
        <QuerySource :dbName="dbName" :colName="'maps'"></QuerySource>
    </div> -->

    <!-- traits effects events -->
    <div class="row" style="font-size:20px;">装备/状态/职业给的数值:</div>
    <QueryEquipParams :dbName="dbName"></QueryEquipParams>
    <div class="row mt-4 mp-4"></div>
    <div class="row" style="font-size:20px;">装备/状态/职业给的其他能力:</div>
    <QueryOtherAbilities :dbName="dbName"></QueryOtherAbilities>
    <div class="row mt-4 mp-4"></div>
    <div class="row" style="font-size:20px;">恢复(包含高贵的负回复):</div>
    <QueryRegeneration :dbName="dbName"></QueryRegeneration>
    <div class="row mt-4 mp-4"></div>
    <div class="row" style="font-size:20px;">状态附加与抗性:</div>
    <QueryState :dbName="dbName"></QueryState>
    <div class="row mt-4 mp-4"></div>

    <!-- 给select下拉框预留空间 -->
    <div class="row mt-5 mp-5 pt-5 pb-5"></div>
</template>
  
<script>
import QueryEquipParams from "./QueryEquipParams.vue";
import QuerySource from "./QuerySource.vue"
import QueryOtherAbilities from "./QueryOtherAbilities.vue"
import QueryRegeneration from "./QueryRegeneration.vue"
import QueryState from "./QueryState.vue";

export default {
    name: 'OtherQuery',
    components: {
    QuerySource,
    QueryEquipParams,
    QueryOtherAbilities,
    QueryRegeneration,
    QueryState
},
    data() {
        return {

        }
    },
    props: ['dbName'],
    methods: {

    },
    created() {

    }
}
</script>
<style>
.row {
    margin-top: 5px;
}
</style>